module.exports = __webpack_public_path__ + "static/img/service4.eedf549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service4.jpg
// module id = lMnO
// module chunks = 0